import {useNavigate, useLoaderData} from "react-router-dom";
import {useState, useEffect} from "react";
import axios from "axios";
import {Header} from "../layout/header.js";
import {Footer} from "../layout/footer.js";
import learnPageBanner from "../images/learnpage-bg.jpg";
import {GenericBanner} from "../components/genericbanner.js";
import {staticContent} from "../staticdata.js";
import {SearchBar} from "../components/searchbar.js";
import React from 'react';


export function loader(pageId) {
    var staticData;

    staticContent.forEach(staticContentItem => {
        if (pageId === staticContentItem.pageId) {
            staticData = staticContentItem;
        }
    });

    async function func() { return {staticData}; };
    return func;
}


export function StaticPageContent(props) {
    const {staticData} = useLoaderData();
    const navigate = useNavigate();
    const [currentQuery, setCurrentQuery] = useState("");
    let mainBody = null;

    useEffect(() => {
        const form = document.getElementById("contactForm");
        const successMsg = document.getElementById("formSuccess");
        const errorMsg = document.getElementById("formError");

        if (!form) return;

        const handleSubmit = async (e) => {
            e.preventDefault();
            successMsg.classList.add("hidden");
            errorMsg.classList.add("hidden");

            const formData = {
                name: form.name.value,
                email: form.email.value,
                subject: form.subject.value,
                message: form.message.value,
            };

            try {
                const response = await axios.post("/heliodata/app/contact_us_page", formData);
                let countdown = 5;
                if (response.data.success) {
                    successMsg.textContent = `Your message has been sent successfully! Redirecting in ${countdown}...`;
                    successMsg.classList.remove("hidden");
                    const intervalId = setInterval(() => {
                        countdown -= 1;
                        if (countdown > 0) {
                            successMsg.textContent = `Your message has been sent successfully! Redirecting in ${countdown}...`;
                        } else {
                            clearInterval(intervalId);
                            navigate(`/`);
                        }
                    }, 1000);
                } else if (response.data.error) {
                    errorMsg.textContent = `Error code: 500. Internal server error. Please try again later.`;
                    errorMsg.classList.remove("hidden");
                }
            } catch (err) {
                const message = err.response?.data?.error
                                ? `Error code: 500. Internal server error. Please try again later.`
                                :  `Something went wrong!`;
                errorMsg.textContent = `${message}`;
                errorMsg.classList.remove("hidden");
            }
        };

        form.addEventListener("submit", handleSubmit);

        return () => {
            form.removeEventListener("submit", handleSubmit);
        };
    }, []);

    if (staticData === undefined) {
        // redirect to error page
        return <div>Page not found</div>;
    }

    if (typeof staticData.body === 'function') {
      // For pages that need the SearchBar component injected (e.g., downloading-and-acquiring)
      const searchBarComponent = (
        <div className="staticPageSearchWrapper">
          <div className="SearchContent">
            <SearchBar
              centered={true}
              currentQuery={currentQuery}
              setCurrentQuery={setCurrentQuery}
              navigate={navigate}
              placeholder='Enter text to search (e.g., solar wind, Parker Solar Probe, MMS FPI)'
            />
            <div className="staticLandingPageDatasetCount">3K+ datasets</div>
          </div>
        </div>
      );
      mainBody = staticData.body(searchBarComponent);
    } else if (Array.isArray(staticData.body)) {
      // For pages that use an array of elements
      mainBody = <>{staticData.body}</>;
    } else if (React.isValidElement(staticData.body)) {
      // For pages that use a single React element
      mainBody = staticData.body;
    }

    return (
	<>
          <Header wide={false} />
            <GenericBanner
              bannerImage={learnPageBanner}
              title={staticData.title}
              tagline={staticData.tagline}
              articleContent={false}
              breadcrumbLevels={[{text: staticData.title, link: "#"}]}>
            </GenericBanner>
            <div className="pageContainer pageContainerArticleContent">
              {mainBody || ""}
	            {staticData.bodyHtml &&
              <div
                dangerouslySetInnerHTML={{__html: staticData.bodyHtml}} /> }
            </div>
         <Footer />
	</>
    );
}
